<div class="page-header px-3 pt-5">
  <h4 [translationEditableDirective]="title">
    {{ title | translate }}
  </h4>
</div>
